export default "__VITE_ASSET__C$ISQyDe__"